import React from 'react';

export const UploadVendorStateContext = React.createContext({});
